import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-header left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex pb-4" }
const _hoisted_4 = { class: "mr-2 w-1/3" }
const _hoisted_5 = { class: "ml-2 w-2/3" }
const _hoisted_6 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_7 = { class: "text-2xl capitalize" }
const _hoisted_8 = { class: "px-4 py-6 overflow-y-auto scroll-box" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "mr-2 w-1/4" }
const _hoisted_11 = { class: "ml-2 w-3/4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_ButtonSecondary = _resolveComponent("ButtonSecondary")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_SelectCountry = _resolveComponent("SelectCountry")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.errorHeading || _ctx.errorContent)
      ? (_openBlock(), _createBlock(_component_ErrorBox, {
          key: 0,
          heading: _ctx.errorHeading,
          content: _ctx.errorContent,
          fixed: _ctx.errorFixed,
          onCloseError: _cache[0] || (_cache[0] = ($event: any) => {
        _ctx.errorHeading = '';
        _ctx.errorContent = '';
      })
        }, null, 8, ["heading", "content", "fixed"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HeaderShadow),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addRemoteUser && _ctx.addRemoteUser(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/local-admin/remote-users" }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonSecondary, {
                  type: "button",
                  name: _ctx.$t('buttons.cancel'),
                  disabled: _ctx.loading
                }, null, 8, ["name", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              type: "submit",
              name: _ctx.$t('buttons.addVerify'),
              disabled: 
                !_ctx.validateEmail(_ctx.remoteUser.email) ||
                !_ctx.required(_ctx.remoteUser.name) ||
                !_ctx.required(_ctx.remoteUser.phone) ||
                !_ctx.validatePhoneNumber(
                  _ctx.remoteUser.countryCode,
                  _ctx.remoteUser.phone
                ) ||
                _ctx.loading
              ,
              loading: _ctx.loading
            }, null, 8, ["name", "disabled", "loading"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["bg-nucleus-white transition-all", { 'opacity-50': _ctx.loading }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-remote-user" }, null, -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("global.defaults.newRemote")), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Input, {
              id: "name",
              value: _ctx.remoteUser.name,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.remoteUser.name) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.name.label'),
              "max-length": _ctx.inputMaxLengths.name,
              placeholder: _ctx.$t('inputs.name.placeholder'),
              required: ""
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Input, {
              id: "email",
              value: _ctx.remoteUser.email,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.remoteUser.email) = $event)),
              "update:value": _ctx.validateEmail(_ctx.remoteUser.email),
              "input-type": "text",
              label: _ctx.$t('inputs.email.label'),
              "max-length": _ctx.inputMaxLengths.email,
              placeholder: _ctx.$t('inputs.email.placeholder'),
              error: _ctx.error.email,
              required: ""
            }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SelectCountry, {
                  id: "code",
                  value: _ctx.remoteUser.countryCode,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remoteUser.countryCode) = $event)),
                  label: _ctx.$t('inputs.code.label'),
                  options: _ctx.countryCodes,
                  "options-common": _ctx.countryCodesCommon
                }, null, 8, ["value", "label", "options", "options-common"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Input, {
                  id: "phone",
                  value: _ctx.remoteUser.phone,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.remoteUser.phone) = $event)),
                  "update:value": 
                    _ctx.validatePhoneNumber(
                      _ctx.remoteUser.countryCode,
                      _ctx.remoteUser.phone
                    )
                  ,
                  "input-type": "text",
                  label: _ctx.$t('inputs.phone.label'),
                  "max-length": _ctx.inputMaxLengths.phone,
                  placeholder: _ctx.$t('inputs.phone.placeholder'),
                  error: _ctx.error.phone,
                  required: ""
                }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"])
              ])
            ]),
            _createVNode(_component_Input, {
              id: "affiliation",
              value: _ctx.remoteUser.affiliation,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.remoteUser.affiliation) = $event)),
              "input-type": "text",
              label: _ctx.$t('inputs.affiliation.label'),
              "max-length": _ctx.inputMaxLengths.affiliation,
              placeholder: _ctx.$t('inputs.affiliation.placeholder')
            }, null, 8, ["value", "label", "max-length", "placeholder"]),
            _createVNode(_component_Textarea, {
              id: "notes",
              value: _ctx.remoteUser.notes,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.remoteUser.notes) = $event)),
              label: _ctx.$t('inputs.notes.label'),
              "max-length": _ctx.inputMaxLengths.notes,
              placeholder: _ctx.$t('inputs.notes.placeholder')
            }, null, 8, ["value", "label", "max-length", "placeholder"])
          ])
        ], 2)
      ], 32)
    ])
  ]))
}